export default __webpack_public_path__ + "static/media/sch3.05f42748.jpg";